import React from "react";
import { Tooltip } from "react-tooltip";

// Pass 'anchorSelect' or 'clickable' if you want to have clickable tooltip. Find ref in ListPopup
const NewToolTip = ({
  isOpen,
  id,
  render,
  place = "bottom",
  anchorSelect = "",
  clickable = false,
  handleHide = () => {},
  offset = 8,
  positionStrategy,
  middlewares,
}) => {
  return (
    <Tooltip
      isOpen={isOpen}
      id={id}
      arrowColor="#E0E0E0"
      place={place}
      offset={offset}
      positionStrategy={positionStrategy}
      middlewares={middlewares}
      style={{ backgroundColor: "transparent" }}
      className="!z-50 !opacity-100 !p-0 !rounded-[8px] !border-[2px] !border-gray-100 !overflow-hidden !whitespace-normal toolTipDropShadow"
      render={render}
      clickable={anchorSelect.length > 0 || clickable}
      anchorSelect={anchorSelect}
      afterHide={handleHide}
    />
  );
};

export default NewToolTip;
